import { Box, Checkbox, Flex, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { canHoldGoal } from '../../utils/goals';

/**
 * The accounts that hold a goal's money. Only the user's own accounts are
 * offered: a card or a loan stands on the other side of a movement, so it can
 * spend goal money but never hold it.
 */
export default function GoalAccountsPicker({ accounts, selectedIds, onChange }) {
  const { t } = useTranslation('goals');
  const options = accounts.filter(canHoldGoal);

  const toggle = (id) => {
    onChange(selectedIds.includes(id)
      ? selectedIds.filter((x) => x !== id)
      : [...selectedIds, id]);
  };

  return (
    <Box>
      <VStack align="stretch" spacing={0} border="1px solid" borderColor="redesign.border" borderRadius="lg" maxH="220px" overflowY="auto" overflowX="hidden">
        {options.map((account) => (
          <Flex key={account.id} px={3} py={2} align="center" _hover={{ bg: 'redesign.bg.hover' }}>
            <Checkbox
              isChecked={selectedIds.includes(account.id)}
              onChange={() => toggle(account.id)}
              size="sm"
              w="100%"
            >
              <Text fontSize="sm" color="redesign.heading" isTruncated>{account.name}</Text>
            </Checkbox>
          </Flex>
        ))}
      </VStack>
      <Text fontSize="xs" color="redesign.text.muted" mt={2}>{t('fields.accountsHint')}</Text>
    </Box>
  );
}
